import { memo, useMemo } from 'react';
// @ts-expect-error
import { RouterProvider } from 'react-router/dom';
import { type RouteObject, type DOMRouterOpts, createBrowserRouter, Outlet, useNavigate } from 'react-router';
import { navigateEvent } from '@epihub/core/src/routes';
import { useEventListener } from '../events/useEventListener';

type EpihubRouterProps = {
  routes: RouteObject[];
  opts?: DOMRouterOpts;
};

export const EpihubRouter = memo(({ routes, opts }: EpihubRouterProps) => {
  const router = useMemo(() => {
    return createBrowserRouter([{
      element: <EpihubRootRoute />,
      children: routes,
    }], opts);
  }, [routes, opts]);

  return (
    <RouterProvider
      router={router}
    />
  );
});

const EpihubRootRoute = () => {
  const navigate = useNavigate();

  useEventListener(navigateEvent({}), ({ to, options }) => {
    navigate(to, options);
  });

  return <Outlet />;
};
